import { WorkoutFilters } from '../models/workout-filters';
import { partitionWorkoutFilters } from './partition-workout-filters';

// TODO: What should this look like for postgres? Using dalton-pg? Or another orm? Below is a copy-paste of our mongo version!
// TODO: BRT-12
export function workoutFiltersToPostgresQuery(workoutFilters: WorkoutFilters): {
  $in?: string[];
  $nin?: string[];
  $all?: string[];
} {
  if (!workoutFilters || !workoutFilters.length) {
    return {};
  }

  const { allowed, excluded, required } =
    partitionWorkoutFilters(workoutFilters);

  return {
    ...(allowed.length && { $in: allowed }),
    ...(excluded.length && { $nin: excluded }),
    ...(required.length && { $all: required }),
  };
}
